// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptInviteData, AcceptInviteErrors, AcceptInviteResponses, AssignDriverData, AssignDriverErrors, AssignDriverResponses, AutocompleteData, AutocompleteErrors, AutocompleteResponses, ConfirmCashPaymentData, ConfirmCashPaymentErrors, ConfirmCashPaymentResponses, ConfirmLogoUploadData, ConfirmLogoUploadErrors, ConfirmLogoUploadResponses, ConfirmOrgLogoUploadData, ConfirmOrgLogoUploadErrors, ConfirmOrgLogoUploadResponses, ConfirmProductImageUploadData, ConfirmProductImageUploadErrors, ConfirmProductImageUploadResponses, CreateAddressData, CreateAddressErrors, CreateAddressResponses, CreateCustomerData, CreateCustomerErrors, CreateCustomerResponses, CreateDeliveryDriverData, CreateDeliveryDriverErrors, CreateDeliveryDriverResponses, CreateDriverInviteCodeData, CreateDriverInviteCodeErrors, CreateDriverInviteCodeResponses, CreateGasStationData, CreateGasStationErrors, CreateGasStationResponses, CreateInviteData, CreateInviteErrors, CreateInviteResponses, CreateOrderData, CreateOrderErrors, CreateOrderResponses, CreateOrderWithNewCustomerData, CreateOrderWithNewCustomerErrors, CreateOrderWithNewCustomerResponses, CreateOrganizationData, CreateOrganizationErrors, CreateOrganizationResponses, CreateProductData, CreateProductErrors, CreateProductResponses, CustomerCreateOrderData, CustomerCreateOrderErrors, CustomerCreateOrderResponses, CustomerCreatePaymentData, CustomerCreatePaymentErrors, CustomerCreatePaymentResponses, CustomerGetOrderData, CustomerGetOrderErrors, CustomerGetOrderResponses, CustomerInitiateTestPaymentData, CustomerInitiateTestPaymentErrors, CustomerInitiateTestPaymentResponses, CustomerLinkOrganizationData, CustomerLinkOrganizationErrors, CustomerLinkOrganizationResponses, CustomerListGasStationsData, CustomerListGasStationsErrors, CustomerListGasStationsResponses, CustomerListOrdersData, CustomerListOrdersErrors, CustomerListOrdersResponses, CustomerListProductsData, CustomerListProductsErrors, CustomerListProductsResponses, CustomerLoginData, CustomerLoginErrors, CustomerLoginResponses, CustomerLogoutData, CustomerLogoutErrors, CustomerLogoutResponses, CustomerMeData, CustomerMeErrors, CustomerMeResponses, CustomerRegisterData, CustomerRegisterErrors, CustomerRegisterResponses, CustomerUpdatePaymentMethodData, CustomerUpdatePaymentMethodErrors, CustomerUpdatePaymentMethodResponses, CustomerValidateTokenData, CustomerValidateTokenErrors, CustomerValidateTokenResponses, DeactivateDriverInviteCodeData, DeactivateDriverInviteCodeErrors, DeactivateDriverInviteCodeResponses, DeleteAddressData, DeleteAddressErrors, DeleteAddressResponses, DeleteCustomerData, DeleteCustomerErrors, DeleteCustomerResponses, DeleteDeliveryDriverData, DeleteDeliveryDriverErrors, DeleteDeliveryDriverResponses, DeleteGasStationData, DeleteGasStationErrors, DeleteGasStationLogoData, DeleteGasStationLogoErrors, DeleteGasStationLogoResponses, DeleteGasStationResponses, DeleteInventoryData, DeleteInventoryErrors, DeleteInventoryResponses, DeleteOrganizationData, DeleteOrganizationErrors, DeleteOrganizationLogoData, DeleteOrganizationLogoErrors, DeleteOrganizationLogoResponses, DeleteOrganizationResponses, DeletePaymentClientData, DeletePaymentClientErrors, DeletePaymentClientResponses, DeleteProductData, DeleteProductErrors, DeleteProductImageData, DeleteProductImageErrors, DeleteProductImageResponses, DeleteProductResponses, DirectionsData, DirectionsErrors, DirectionsResponses, DriverGetCustomerSignupQrData, DriverGetCustomerSignupQrErrors, DriverGetCustomerSignupQrResponses, DriverGetOrderData, DriverGetOrderErrors, DriverGetOrderResponses, DriverListOrdersData, DriverListOrdersErrors, DriverListOrdersResponses, DriverLoginData, DriverLoginErrors, DriverLoginResponses, DriverLogoutData, DriverLogoutErrors, DriverLogoutResponses, DriverMeData, DriverMeErrors, DriverMeResponses, DriverRegisterData, DriverRegisterErrors, DriverRegisterResponses, DriverUpdateLocationData, DriverUpdateLocationErrors, DriverUpdateLocationResponses, DriverUpdateOrderStatusData, DriverUpdateOrderStatusErrors, DriverUpdateOrderStatusResponses, GasAdminLoginData, GasAdminLoginErrors, GasAdminLoginResponses, GasAdminLogoutData, GasAdminLogoutErrors, GasAdminLogoutResponses, GasAdminMeData, GasAdminMeErrors, GasAdminMeResponses, GasAdminRegisterData, GasAdminRegisterErrors, GasAdminRegisterResponses, GeocodeData, GeocodeErrors, GeocodeResponses, GetAddressData, GetAddressErrors, GetAddressResponses, GetCustomerData, GetCustomerErrors, GetCustomerResponses, GetCustomerSignupQrData, GetCustomerSignupQrErrors, GetCustomerSignupQrResponses, GetDashboardSummaryData, GetDashboardSummaryErrors, GetDashboardSummaryResponses, GetDeliveriesReportData, GetDeliveriesReportErrors, GetDeliveriesReportResponses, GetDeliveryDriverData, GetDeliveryDriverErrors, GetDeliveryDriverResponses, GetDeliveryTimeReportData, GetDeliveryTimeReportErrors, GetDeliveryTimeReportResponses, GetDriverInviteCodeData, GetDriverInviteCodeErrors, GetDriverInviteCodeResponses, GetGasStationData, GetGasStationErrors, GetGasStationResponses, GetLogoUploadUrlData, GetLogoUploadUrlErrors, GetLogoUploadUrlResponses, GetOrderData, GetOrderErrors, GetOrderResponses, GetOrdersReportData, GetOrdersReportErrors, GetOrdersReportResponses, GetOrganizationData, GetOrganizationErrors, GetOrganizationResponses, GetOrgLogoUploadUrlData, GetOrgLogoUploadUrlErrors, GetOrgLogoUploadUrlResponses, GetPaymentClientData, GetPaymentClientErrors, GetPaymentClientResponses, GetProductData, GetProductErrors, GetProductImageStagingUploadUrlData, GetProductImageStagingUploadUrlErrors, GetProductImageStagingUploadUrlResponses, GetProductImageUploadUrlData, GetProductImageUploadUrlErrors, GetProductImageUploadUrlResponses, GetProductResponses, GetRevenueReportData, GetRevenueReportErrors, GetRevenueReportResponses, ListAddressesData, ListAddressesErrors, ListAddressesResponses, ListCustomerOrdersData, ListCustomerOrdersErrors, ListCustomerOrdersResponses, ListCustomersData, ListCustomersErrors, ListCustomersResponses, ListDeliveryDriversData, ListDeliveryDriversErrors, ListDeliveryDriversResponses, ListGasStationsData, ListGasStationsErrors, ListGasStationsResponses, ListInventoryData, ListInventoryErrors, ListInventoryResponses, ListInvitesData, ListInvitesErrors, ListInvitesResponses, ListMembersData, ListMembersErrors, ListMembersResponses, ListMyOrganizationsData, ListMyOrganizationsErrors, ListMyOrganizationsResponses, ListOrdersData, ListOrdersErrors, ListOrdersResponses, ListPaymentClientsData, ListPaymentClientsErrors, ListPaymentClientsResponses, ListProductPriceHistoryData, ListProductPriceHistoryErrors, ListProductPriceHistoryResponses, ListProductsData, ListProductsErrors, ListProductsResponses, PlaceDetailsData, PlaceDetailsErrors, PlaceDetailsResponses, RemoveMemberData, RemoveMemberErrors, RemoveMemberResponses, ReorderProductImagesData, ReorderProductImagesErrors, ReorderProductImagesResponses, ReverseGeocodeData, ReverseGeocodeErrors, ReverseGeocodeResponses, RevokeInviteData, RevokeInviteErrors, RevokeInviteResponses, SearchAddressesData, SearchAddressesErrors, SearchAddressesResponses, SearchCustomersData, SearchCustomersErrors, SearchCustomersResponses, SetInventoryData, SetInventoryErrors, SetInventoryResponses, SetPrimaryProductImageData, SetPrimaryProductImageErrors, SetPrimaryProductImageResponses, UpdateAddressData, UpdateAddressErrors, UpdateAddressResponses, UpdateCustomerData, UpdateCustomerErrors, UpdateCustomerResponses, UpdateDeliveryDriverData, UpdateDeliveryDriverErrors, UpdateDeliveryDriverResponses, UpdateGasStationData, UpdateGasStationErrors, UpdateGasStationResponses, UpdateOrderPaymentMethodData, UpdateOrderPaymentMethodErrors, UpdateOrderPaymentMethodResponses, UpdateOrderStatusData, UpdateOrderStatusErrors, UpdateOrderStatusResponses, UpdateOrganizationData, UpdateOrganizationErrors, UpdateOrganizationResponses, UpdatePaymentClientStatusData, UpdatePaymentClientStatusErrors, UpdatePaymentClientStatusResponses, UpdateProductData, UpdateProductErrors, UpdateProductResponses, UpsertMomopayData, UpsertMomopayErrors, UpsertMomopayResponses, UpsertTestData, UpsertTestErrors, UpsertTestResponses, UpsertVnpayData, UpsertVnpayErrors, UpsertVnpayResponses, ValidateInviteData, ValidateInviteErrors, ValidateInviteResponses, WsDriverHandlerData, WsDriverHandlerErrors, WsGasAdminHandlerData, WsGasAdminHandlerErrors } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Link authenticated customer to a new organization using a QR token
 * This is used when an already-registered customer scans a QR code for a new gas station
 */
export const customerLinkOrganization = <ThrowOnError extends boolean = false>(options: Options<CustomerLinkOrganizationData, ThrowOnError>) => (options.client ?? client).post<CustomerLinkOrganizationResponses, CustomerLinkOrganizationErrors, ThrowOnError>({
    url: '/customers/auth/link-organization',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login with customer credentials (username or phone)
 * Optionally accepts a signup token to link the user to a new organization
 */
export const customerLogin = <ThrowOnError extends boolean = false>(options: Options<CustomerLoginData, ThrowOnError>) => (options.client ?? client).post<CustomerLoginResponses, CustomerLoginErrors, ThrowOnError>({
    url: '/customers/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Logout current customer
 */
export const customerLogout = <ThrowOnError extends boolean = false>(options?: Options<CustomerLogoutData, ThrowOnError>) => (options?.client ?? client).post<CustomerLogoutResponses, CustomerLogoutErrors, ThrowOnError>({ url: '/customers/auth/logout', ...options });

/**
 * Get current customer info
 */
export const customerMe = <ThrowOnError extends boolean = false>(options?: Options<CustomerMeData, ThrowOnError>) => (options?.client ?? client).get<CustomerMeResponses, CustomerMeErrors, ThrowOnError>({ url: '/customers/auth/me', ...options });

/**
 * Register a new customer with QR code token
 * Automatically logs in the customer after successful registration
 */
export const customerRegister = <ThrowOnError extends boolean = false>(options: Options<CustomerRegisterData, ThrowOnError>) => (options.client ?? client).post<CustomerRegisterResponses, CustomerRegisterErrors, ThrowOnError>({
    url: '/customers/auth/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate a QR code token (check if it's valid before showing registration form)
 */
export const customerValidateToken = <ThrowOnError extends boolean = false>(options: Options<CustomerValidateTokenData, ThrowOnError>) => (options.client ?? client).get<CustomerValidateTokenResponses, CustomerValidateTokenErrors, ThrowOnError>({ url: '/customers/auth/validate-token', ...options });

/**
 * List gas stations available to the customer
 *
 * Returns gas stations from all organizations where the customer has a profile.
 */
export const customerListGasStations = <ThrowOnError extends boolean = false>(options?: Options<CustomerListGasStationsData, ThrowOnError>) => (options?.client ?? client).get<CustomerListGasStationsResponses, CustomerListGasStationsErrors, ThrowOnError>({ url: '/customers/catalog/gas-stations', ...options });

/**
 * List products available at a gas station
 *
 * Only returns products with inventory at the specified gas station.
 * Customer must have a profile in the organization that owns the gas station.
 */
export const customerListProducts = <ThrowOnError extends boolean = false>(options: Options<CustomerListProductsData, ThrowOnError>) => (options.client ?? client).get<CustomerListProductsResponses, CustomerListProductsErrors, ThrowOnError>({ url: '/customers/catalog/gas-stations/{gas_station_id}/products', ...options });

/**
 * List orders for current customer (across all profiles)
 */
export const customerListOrders = <ThrowOnError extends boolean = false>(options?: Options<CustomerListOrdersData, ThrowOnError>) => (options?.client ?? client).get<CustomerListOrdersResponses, CustomerListOrdersErrors, ThrowOnError>({ url: '/customers/orders', ...options });

/**
 * Create a new order
 *
 * Creates an order at the specified gas station. The customer must have a profile
 * in the organization that owns the gas station.
 */
export const customerCreateOrder = <ThrowOnError extends boolean = false>(options: Options<CustomerCreateOrderData, ThrowOnError>) => (options.client ?? client).post<CustomerCreateOrderResponses, CustomerCreateOrderErrors, ThrowOnError>({
    url: '/customers/orders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get order details for customer
 */
export const customerGetOrder = <ThrowOnError extends boolean = false>(options: Options<CustomerGetOrderData, ThrowOnError>) => (options.client ?? client).get<CustomerGetOrderResponses, CustomerGetOrderErrors, ThrowOnError>({ url: '/customers/orders/{order_id}', ...options });

/**
 * Update payment method on a customer's order
 */
export const customerUpdatePaymentMethod = <ThrowOnError extends boolean = false>(options: Options<CustomerUpdatePaymentMethodData, ThrowOnError>) => (options.client ?? client).put<CustomerUpdatePaymentMethodResponses, CustomerUpdatePaymentMethodErrors, ThrowOnError>({
    url: '/customers/orders/{order_id}/payment-method',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a payment for a customer order
 *
 * Creates a payment with the specified provider (MomoPay, VNPay, etc.)
 * and returns the payment URL for the customer to complete payment.
 */
export const customerCreatePayment = <ThrowOnError extends boolean = false>(options: Options<CustomerCreatePaymentData, ThrowOnError>) => (options.client ?? client).post<CustomerCreatePaymentResponses, CustomerCreatePaymentErrors, ThrowOnError>({
    url: '/customers/orders/{order_id}/payments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Initiate a test payment for an order
 */
export const customerInitiateTestPayment = <ThrowOnError extends boolean = false>(options: Options<CustomerInitiateTestPaymentData, ThrowOnError>) => (options.client ?? client).post<CustomerInitiateTestPaymentResponses, CustomerInitiateTestPaymentErrors, ThrowOnError>({
    url: '/customers/orders/{order_id}/payments/test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update driver's current location
 */
export const driverUpdateLocation = <ThrowOnError extends boolean = false>(options: Options<DriverUpdateLocationData, ThrowOnError>) => (options.client ?? client).post<DriverUpdateLocationResponses, DriverUpdateLocationErrors, ThrowOnError>({
    url: '/drivers/api/location',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login with driver credentials
 */
export const driverLogin = <ThrowOnError extends boolean = false>(options: Options<DriverLoginData, ThrowOnError>) => (options.client ?? client).post<DriverLoginResponses, DriverLoginErrors, ThrowOnError>({
    url: '/drivers/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Logout current driver
 */
export const driverLogout = <ThrowOnError extends boolean = false>(options?: Options<DriverLogoutData, ThrowOnError>) => (options?.client ?? client).post<DriverLogoutResponses, DriverLogoutErrors, ThrowOnError>({ url: '/drivers/auth/logout', ...options });

/**
 * Get current driver info
 */
export const driverMe = <ThrowOnError extends boolean = false>(options?: Options<DriverMeData, ThrowOnError>) => (options?.client ?? client).get<DriverMeResponses, DriverMeErrors, ThrowOnError>({ url: '/drivers/auth/me', ...options });

/**
 * Register a new driver with invite code
 */
export const driverRegister = <ThrowOnError extends boolean = false>(options: Options<DriverRegisterData, ThrowOnError>) => (options.client ?? client).post<DriverRegisterResponses, DriverRegisterErrors, ThrowOnError>({
    url: '/drivers/auth/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List orders assigned to the current driver
 */
export const driverListOrders = <ThrowOnError extends boolean = false>(options?: Options<DriverListOrdersData, ThrowOnError>) => (options?.client ?? client).get<DriverListOrdersResponses, DriverListOrdersErrors, ThrowOnError>({ url: '/drivers/orders', ...options });

/**
 * Get a single order by ID (for driver)
 */
export const driverGetOrder = <ThrowOnError extends boolean = false>(options: Options<DriverGetOrderData, ThrowOnError>) => (options.client ?? client).get<DriverGetOrderResponses, DriverGetOrderErrors, ThrowOnError>({ url: '/drivers/orders/{id}', ...options });

/**
 * Update order status (for driver - can mark as delivered)
 */
export const driverUpdateOrderStatus = <ThrowOnError extends boolean = false>(options: Options<DriverUpdateOrderStatusData, ThrowOnError>) => (options.client ?? client).put<DriverUpdateOrderStatusResponses, DriverUpdateOrderStatusErrors, ThrowOnError>({
    url: '/drivers/orders/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get QR code for customer signup (for unregistered customers)
 */
export const driverGetCustomerSignupQr = <ThrowOnError extends boolean = false>(options: Options<DriverGetCustomerSignupQrData, ThrowOnError>) => (options.client ?? client).get<DriverGetCustomerSignupQrResponses, DriverGetCustomerSignupQrErrors, ThrowOnError>({ url: '/drivers/orders/{order_id}/customer-signup-qr', ...options });

/**
 * List all payment clients for an organization
 */
export const listPaymentClients = <ThrowOnError extends boolean = false>(options: Options<ListPaymentClientsData, ThrowOnError>) => (options.client ?? client).get<ListPaymentClientsResponses, ListPaymentClientsErrors, ThrowOnError>({ url: '/gas_admin/api/organizations/{org_id}/payment-clients', ...options });

/**
 * Create or update MomoPay configuration
 */
export const upsertMomopay = <ThrowOnError extends boolean = false>(options: Options<UpsertMomopayData, ThrowOnError>) => (options.client ?? client).put<UpsertMomopayResponses, UpsertMomopayErrors, ThrowOnError>({
    url: '/gas_admin/api/organizations/{org_id}/payment-clients/momopay',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable or disable Test payment provider
 */
export const upsertTest = <ThrowOnError extends boolean = false>(options: Options<UpsertTestData, ThrowOnError>) => (options.client ?? client).put<UpsertTestResponses, UpsertTestErrors, ThrowOnError>({
    url: '/gas_admin/api/organizations/{org_id}/payment-clients/test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update VNPay configuration
 */
export const upsertVnpay = <ThrowOnError extends boolean = false>(options: Options<UpsertVnpayData, ThrowOnError>) => (options.client ?? client).put<UpsertVnpayResponses, UpsertVnpayErrors, ThrowOnError>({
    url: '/gas_admin/api/organizations/{org_id}/payment-clients/vnpay',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a payment client
 */
export const deletePaymentClient = <ThrowOnError extends boolean = false>(options: Options<DeletePaymentClientData, ThrowOnError>) => (options.client ?? client).delete<DeletePaymentClientResponses, DeletePaymentClientErrors, ThrowOnError>({ url: '/gas_admin/api/organizations/{org_id}/payment-clients/{provider}', ...options });

/**
 * Get a specific payment client by provider
 */
export const getPaymentClient = <ThrowOnError extends boolean = false>(options: Options<GetPaymentClientData, ThrowOnError>) => (options.client ?? client).get<GetPaymentClientResponses, GetPaymentClientErrors, ThrowOnError>({ url: '/gas_admin/api/organizations/{org_id}/payment-clients/{provider}', ...options });

/**
 * Update payment client status (enable/disable)
 */
export const updatePaymentClientStatus = <ThrowOnError extends boolean = false>(options: Options<UpdatePaymentClientStatusData, ThrowOnError>) => (options.client ?? client).patch<UpdatePaymentClientStatusResponses, UpdatePaymentClientStatusErrors, ThrowOnError>({
    url: '/gas_admin/api/organizations/{org_id}/payment-clients/{provider}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate an invite token (public — no auth)
 *
 * Returns the org context for an invite link so the registration page can
 * render a banner and prefill the email. If the email is already a registered
 * user, the frontend should route to /login instead.
 */
export const validateInvite = <ThrowOnError extends boolean = false>(options: Options<ValidateInviteData, ThrowOnError>) => (options.client ?? client).get<ValidateInviteResponses, ValidateInviteErrors, ThrowOnError>({ url: '/gas_admin/auth/invite', ...options });

/**
 * Accept an invite as the currently logged-in user
 *
 * Used when the invitee already had an account. The invite's email must match
 * the logged-in user's email.
 */
export const acceptInvite = <ThrowOnError extends boolean = false>(options: Options<AcceptInviteData, ThrowOnError>) => (options.client ?? client).post<AcceptInviteResponses, AcceptInviteErrors, ThrowOnError>({
    url: '/gas_admin/auth/invite/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login with credentials
 */
export const gasAdminLogin = <ThrowOnError extends boolean = false>(options: Options<GasAdminLoginData, ThrowOnError>) => (options.client ?? client).post<GasAdminLoginResponses, GasAdminLoginErrors, ThrowOnError>({
    url: '/gas_admin/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Logout current user
 */
export const gasAdminLogout = <ThrowOnError extends boolean = false>(options?: Options<GasAdminLogoutData, ThrowOnError>) => (options?.client ?? client).post<GasAdminLogoutResponses, GasAdminLogoutErrors, ThrowOnError>({ url: '/gas_admin/auth/logout', ...options });

/**
 * Get current user info
 */
export const gasAdminMe = <ThrowOnError extends boolean = false>(options?: Options<GasAdminMeData, ThrowOnError>) => (options?.client ?? client).get<GasAdminMeResponses, GasAdminMeErrors, ThrowOnError>({ url: '/gas_admin/auth/me', ...options });

/**
 * Register a new user
 */
export const gasAdminRegister = <ThrowOnError extends boolean = false>(options: Options<GasAdminRegisterData, ThrowOnError>) => (options.client ?? client).post<GasAdminRegisterResponses, GasAdminRegisterErrors, ThrowOnError>({
    url: '/gas_admin/auth/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get organizations for the current user
 */
export const listMyOrganizations = <ThrowOnError extends boolean = false>(options?: Options<ListMyOrganizationsData, ThrowOnError>) => (options?.client ?? client).get<ListMyOrganizationsResponses, ListMyOrganizationsErrors, ThrowOnError>({ url: '/gas_admin/organizations', ...options });

/**
 * Create a new organization
 */
export const createOrganization = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationData, ThrowOnError>) => (options.client ?? client).post<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError>({
    url: '/gas_admin/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an organization
 */
export const deleteOrganization = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganizationData, ThrowOnError>) => (options.client ?? client).delete<DeleteOrganizationResponses, DeleteOrganizationErrors, ThrowOnError>({ url: '/gas_admin/organizations/{id}', ...options });

/**
 * Get a single organization by ID
 */
export const getOrganization = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError>({ url: '/gas_admin/organizations/{id}', ...options });

/**
 * Update an organization
 */
export const updateOrganization = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationData, ThrowOnError>) => (options.client ?? client).put<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an organization's logo
 */
export const deleteOrganizationLogo = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganizationLogoData, ThrowOnError>) => (options.client ?? client).delete<DeleteOrganizationLogoResponses, DeleteOrganizationLogoErrors, ThrowOnError>({ url: '/gas_admin/organizations/{id}/logo', ...options });

/**
 * Confirm an organization logo upload was completed
 *
 * After uploading a file directly to the presigned URL, call this endpoint to confirm
 * the upload and update the organization's logo.
 */
export const confirmOrgLogoUpload = <ThrowOnError extends boolean = false>(options: Options<ConfirmOrgLogoUploadData, ThrowOnError>) => (options.client ?? client).post<ConfirmOrgLogoUploadResponses, ConfirmOrgLogoUploadErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{id}/logo/confirm/{upload_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a presigned URL for uploading an organization logo
 *
 * This endpoint returns a presigned URL that allows direct upload to S3-compatible storage.
 * After uploading to the presigned URL, call the confirm endpoint to complete the process.
 */
export const getOrgLogoUploadUrl = <ThrowOnError extends boolean = false>(options: Options<GetOrgLogoUploadUrlData, ThrowOnError>) => (options.client ?? client).post<GetOrgLogoUploadUrlResponses, GetOrgLogoUploadUrlErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{id}/logo/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all addresses for an organization
 */
export const listAddresses = <ThrowOnError extends boolean = false>(options: Options<ListAddressesData, ThrowOnError>) => (options.client ?? client).get<ListAddressesResponses, ListAddressesErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/addresses', ...options });

/**
 * Create a new address
 */
export const createAddress = <ThrowOnError extends boolean = false>(options: Options<CreateAddressData, ThrowOnError>) => (options.client ?? client).post<CreateAddressResponses, CreateAddressErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/addresses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search addresses by text query
 */
export const searchAddresses = <ThrowOnError extends boolean = false>(options: Options<SearchAddressesData, ThrowOnError>) => (options.client ?? client).get<SearchAddressesResponses, SearchAddressesErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/addresses/search', ...options });

/**
 * Delete an address
 */
export const deleteAddress = <ThrowOnError extends boolean = false>(options: Options<DeleteAddressData, ThrowOnError>) => (options.client ?? client).delete<DeleteAddressResponses, DeleteAddressErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/addresses/{id}', ...options });

/**
 * Get a specific address
 */
export const getAddress = <ThrowOnError extends boolean = false>(options: Options<GetAddressData, ThrowOnError>) => (options.client ?? client).get<GetAddressResponses, GetAddressErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/addresses/{id}', ...options });

/**
 * Update an existing address
 */
export const updateAddress = <ThrowOnError extends boolean = false>(options: Options<UpdateAddressData, ThrowOnError>) => (options.client ?? client).put<UpdateAddressResponses, UpdateAddressErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/addresses/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all customers for an organization
 */
export const listCustomers = <ThrowOnError extends boolean = false>(options: Options<ListCustomersData, ThrowOnError>) => (options.client ?? client).get<ListCustomersResponses, ListCustomersErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/customers', ...options });

/**
 * Create a new customer
 */
export const createCustomer = <ThrowOnError extends boolean = false>(options: Options<CreateCustomerData, ThrowOnError>) => (options.client ?? client).post<CreateCustomerResponses, CreateCustomerErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/customers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search customers for typeahead
 */
export const searchCustomers = <ThrowOnError extends boolean = false>(options: Options<SearchCustomersData, ThrowOnError>) => (options.client ?? client).get<SearchCustomersResponses, SearchCustomersErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/customers/search', ...options });

/**
 * List orders for a specific customer
 */
export const listCustomerOrders = <ThrowOnError extends boolean = false>(options: Options<ListCustomerOrdersData, ThrowOnError>) => (options.client ?? client).get<ListCustomerOrdersResponses, ListCustomerOrdersErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/customers/{customer_id}/orders', ...options });

/**
 * Delete a customer
 */
export const deleteCustomer = <ThrowOnError extends boolean = false>(options: Options<DeleteCustomerData, ThrowOnError>) => (options.client ?? client).delete<DeleteCustomerResponses, DeleteCustomerErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/customers/{id}', ...options });

/**
 * Get a single customer
 */
export const getCustomer = <ThrowOnError extends boolean = false>(options: Options<GetCustomerData, ThrowOnError>) => (options.client ?? client).get<GetCustomerResponses, GetCustomerErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/customers/{id}', ...options });

/**
 * Update a customer
 */
export const updateCustomer = <ThrowOnError extends boolean = false>(options: Options<UpdateCustomerData, ThrowOnError>) => (options.client ?? client).put<UpdateCustomerResponses, UpdateCustomerErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/customers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get QR code for customer signup
 *
 * Generates a QR code that an unregistered customer can scan to create their account.
 * The customer must not already be registered.
 */
export const getCustomerSignupQr = <ThrowOnError extends boolean = false>(options: Options<GetCustomerSignupQrData, ThrowOnError>) => (options.client ?? client).get<GetCustomerSignupQrResponses, GetCustomerSignupQrErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/customers/{id}/signup-qr', ...options });

/**
 * List all delivery drivers for an organization
 */
export const listDeliveryDrivers = <ThrowOnError extends boolean = false>(options: Options<ListDeliveryDriversData, ThrowOnError>) => (options.client ?? client).get<ListDeliveryDriversResponses, ListDeliveryDriversErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/delivery-drivers', ...options });

/**
 * Create a new delivery driver
 */
export const createDeliveryDriver = <ThrowOnError extends boolean = false>(options: Options<CreateDeliveryDriverData, ThrowOnError>) => (options.client ?? client).post<CreateDeliveryDriverResponses, CreateDeliveryDriverErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/delivery-drivers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivate the invite code for a specific driver
 */
export const deactivateDriverInviteCode = <ThrowOnError extends boolean = false>(options: Options<DeactivateDriverInviteCodeData, ThrowOnError>) => (options.client ?? client).delete<DeactivateDriverInviteCodeResponses, DeactivateDriverInviteCodeErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/delivery-drivers/{driver_id}/invite-code', ...options });

/**
 * Get the invite code for a specific driver
 */
export const getDriverInviteCode = <ThrowOnError extends boolean = false>(options: Options<GetDriverInviteCodeData, ThrowOnError>) => (options.client ?? client).get<GetDriverInviteCodeResponses, GetDriverInviteCodeErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/delivery-drivers/{driver_id}/invite-code', ...options });

/**
 * Create/regenerate an invite code for a specific driver
 */
export const createDriverInviteCode = <ThrowOnError extends boolean = false>(options: Options<CreateDriverInviteCodeData, ThrowOnError>) => (options.client ?? client).post<CreateDriverInviteCodeResponses, CreateDriverInviteCodeErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/delivery-drivers/{driver_id}/invite-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a delivery driver
 */
export const deleteDeliveryDriver = <ThrowOnError extends boolean = false>(options: Options<DeleteDeliveryDriverData, ThrowOnError>) => (options.client ?? client).delete<DeleteDeliveryDriverResponses, DeleteDeliveryDriverErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/delivery-drivers/{id}', ...options });

/**
 * Get a single delivery driver
 */
export const getDeliveryDriver = <ThrowOnError extends boolean = false>(options: Options<GetDeliveryDriverData, ThrowOnError>) => (options.client ?? client).get<GetDeliveryDriverResponses, GetDeliveryDriverErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/delivery-drivers/{id}', ...options });

/**
 * Update a delivery driver
 */
export const updateDeliveryDriver = <ThrowOnError extends boolean = false>(options: Options<UpdateDeliveryDriverData, ThrowOnError>) => (options.client ?? client).put<UpdateDeliveryDriverResponses, UpdateDeliveryDriverErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/delivery-drivers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all gas stations for an organization
 */
export const listGasStations = <ThrowOnError extends boolean = false>(options: Options<ListGasStationsData, ThrowOnError>) => (options.client ?? client).get<ListGasStationsResponses, ListGasStationsErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/gas-stations', ...options });

/**
 * Create a new gas station
 */
export const createGasStation = <ThrowOnError extends boolean = false>(options: Options<CreateGasStationData, ThrowOnError>) => (options.client ?? client).post<CreateGasStationResponses, CreateGasStationErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/gas-stations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a gas station
 */
export const deleteGasStation = <ThrowOnError extends boolean = false>(options: Options<DeleteGasStationData, ThrowOnError>) => (options.client ?? client).delete<DeleteGasStationResponses, DeleteGasStationErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/gas-stations/{id}', ...options });

/**
 * Get a single gas station
 */
export const getGasStation = <ThrowOnError extends boolean = false>(options: Options<GetGasStationData, ThrowOnError>) => (options.client ?? client).get<GetGasStationResponses, GetGasStationErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/gas-stations/{id}', ...options });

/**
 * Update a gas station
 */
export const updateGasStation = <ThrowOnError extends boolean = false>(options: Options<UpdateGasStationData, ThrowOnError>) => (options.client ?? client).put<UpdateGasStationResponses, UpdateGasStationErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/gas-stations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a gas station's logo
 */
export const deleteGasStationLogo = <ThrowOnError extends boolean = false>(options: Options<DeleteGasStationLogoData, ThrowOnError>) => (options.client ?? client).delete<DeleteGasStationLogoResponses, DeleteGasStationLogoErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/gas-stations/{id}/logo', ...options });

/**
 * Confirm a logo upload was completed
 *
 * After uploading a file directly to the presigned URL, call this endpoint to confirm
 * the upload and update the gas station's logo.
 */
export const confirmLogoUpload = <ThrowOnError extends boolean = false>(options: Options<ConfirmLogoUploadData, ThrowOnError>) => (options.client ?? client).post<ConfirmLogoUploadResponses, ConfirmLogoUploadErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/gas-stations/{id}/logo/confirm/{upload_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a presigned URL for uploading a gas station logo
 *
 * This endpoint returns a presigned URL that allows direct upload to S3-compatible storage.
 * After uploading to the presigned URL, call the confirm endpoint to complete the process.
 */
export const getLogoUploadUrl = <ThrowOnError extends boolean = false>(options: Options<GetLogoUploadUrlData, ThrowOnError>) => (options.client ?? client).post<GetLogoUploadUrlResponses, GetLogoUploadUrlErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/gas-stations/{id}/logo/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List inventory for a gas station
 */
export const listInventory = <ThrowOnError extends boolean = false>(options: Options<ListInventoryData, ThrowOnError>) => (options.client ?? client).get<ListInventoryResponses, ListInventoryErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/gas-stations/{station_id}/inventory', ...options });

/**
 * Set inventory quantity for a product at a gas station
 */
export const setInventory = <ThrowOnError extends boolean = false>(options: Options<SetInventoryData, ThrowOnError>) => (options.client ?? client).put<SetInventoryResponses, SetInventoryErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/gas-stations/{station_id}/inventory',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete inventory item (remove product from gas station inventory)
 */
export const deleteInventory = <ThrowOnError extends boolean = false>(options: Options<DeleteInventoryData, ThrowOnError>) => (options.client ?? client).delete<DeleteInventoryResponses, DeleteInventoryErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/gas-stations/{station_id}/inventory/{product_id}', ...options });

/**
 * Forward geocode: convert address to coordinates
 */
export const geocode = <ThrowOnError extends boolean = false>(options: Options<GeocodeData, ThrowOnError>) => (options.client ?? client).get<GeocodeResponses, GeocodeErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/geocode', ...options });

/**
 * Autocomplete/typeahead for address search
 */
export const autocomplete = <ThrowOnError extends boolean = false>(options: Options<AutocompleteData, ThrowOnError>) => (options.client ?? client).get<AutocompleteResponses, AutocompleteErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/geocode/autocomplete', ...options });

/**
 * Get directions between two points
 */
export const directions = <ThrowOnError extends boolean = false>(options: Options<DirectionsData, ThrowOnError>) => (options.client ?? client).post<DirectionsResponses, DirectionsErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/geocode/directions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get place details by place ID
 */
export const placeDetails = <ThrowOnError extends boolean = false>(options: Options<PlaceDetailsData, ThrowOnError>) => (options.client ?? client).get<PlaceDetailsResponses, PlaceDetailsErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/geocode/place/{place_id}', ...options });

/**
 * Reverse geocode: convert coordinates to address
 */
export const reverseGeocode = <ThrowOnError extends boolean = false>(options: Options<ReverseGeocodeData, ThrowOnError>) => (options.client ?? client).get<ReverseGeocodeResponses, ReverseGeocodeErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/geocode/reverse', ...options });

/**
 * List pending invites for an organization
 */
export const listInvites = <ThrowOnError extends boolean = false>(options: Options<ListInvitesData, ThrowOnError>) => (options.client ?? client).get<ListInvitesResponses, ListInvitesErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/invites', ...options });

/**
 * Create an invite for a new member
 */
export const createInvite = <ThrowOnError extends boolean = false>(options: Options<CreateInviteData, ThrowOnError>) => (options.client ?? client).post<CreateInviteResponses, CreateInviteErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke a pending invite
 */
export const revokeInvite = <ThrowOnError extends boolean = false>(options: Options<RevokeInviteData, ThrowOnError>) => (options.client ?? client).delete<RevokeInviteResponses, RevokeInviteErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/invites/{invite_id}', ...options });

/**
 * List members of an organization
 */
export const listMembers = <ThrowOnError extends boolean = false>(options: Options<ListMembersData, ThrowOnError>) => (options.client ?? client).get<ListMembersResponses, ListMembersErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/members', ...options });

/**
 * Remove a member from an organization
 */
export const removeMember = <ThrowOnError extends boolean = false>(options: Options<RemoveMemberData, ThrowOnError>) => (options.client ?? client).delete<RemoveMemberResponses, RemoveMemberErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/members/{user_id}', ...options });

/**
 * List all orders for an organization
 */
export const listOrders = <ThrowOnError extends boolean = false>(options: Options<ListOrdersData, ThrowOnError>) => (options.client ?? client).get<ListOrdersResponses, ListOrdersErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/orders', ...options });

/**
 * Create a new order with existing customer
 */
export const createOrder = <ThrowOnError extends boolean = false>(options: Options<CreateOrderData, ThrowOnError>) => (options.client ?? client).post<CreateOrderResponses, CreateOrderErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/orders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a new order with a new customer (inline customer creation)
 */
export const createOrderWithNewCustomer = <ThrowOnError extends boolean = false>(options: Options<CreateOrderWithNewCustomerData, ThrowOnError>) => (options.client ?? client).post<CreateOrderWithNewCustomerResponses, CreateOrderWithNewCustomerErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/orders/with-new-customer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a single order by ID
 */
export const getOrder = <ThrowOnError extends boolean = false>(options: Options<GetOrderData, ThrowOnError>) => (options.client ?? client).get<GetOrderResponses, GetOrderErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/orders/{id}', ...options });

/**
 * Assign a driver to an order
 */
export const assignDriver = <ThrowOnError extends boolean = false>(options: Options<AssignDriverData, ThrowOnError>) => (options.client ?? client).post<AssignDriverResponses, AssignDriverErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/orders/{id}/assign-driver',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm cash payment for an order
 */
export const confirmCashPayment = <ThrowOnError extends boolean = false>(options: Options<ConfirmCashPaymentData, ThrowOnError>) => (options.client ?? client).post<ConfirmCashPaymentResponses, ConfirmCashPaymentErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/orders/{id}/confirm-cash',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update payment method on an order
 */
export const updateOrderPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<UpdateOrderPaymentMethodData, ThrowOnError>) => (options.client ?? client).put<UpdateOrderPaymentMethodResponses, UpdateOrderPaymentMethodErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/orders/{id}/payment-method',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update order status
 */
export const updateOrderStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateOrderStatusData, ThrowOnError>) => (options.client ?? client).put<UpdateOrderStatusResponses, UpdateOrderStatusErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/orders/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a presigned URL for staging a product image upload before the owning
 * product exists. Use with [`create_product`] to attach images atomically.
 */
export const getProductImageStagingUploadUrl = <ThrowOnError extends boolean = false>(options: Options<GetProductImageStagingUploadUrlData, ThrowOnError>) => (options.client ?? client).post<GetProductImageStagingUploadUrlResponses, GetProductImageStagingUploadUrlErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/product-images/staging/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all products for an organization
 */
export const listProducts = <ThrowOnError extends boolean = false>(options: Options<ListProductsData, ThrowOnError>) => (options.client ?? client).get<ListProductsResponses, ListProductsErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/products', ...options });

/**
 * Create a new product
 */
export const createProduct = <ThrowOnError extends boolean = false>(options: Options<CreateProductData, ThrowOnError>) => (options.client ?? client).post<CreateProductResponses, CreateProductErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a product
 */
export const deleteProduct = <ThrowOnError extends boolean = false>(options: Options<DeleteProductData, ThrowOnError>) => (options.client ?? client).delete<DeleteProductResponses, DeleteProductErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/products/{id}', ...options });

/**
 * Get a single product
 */
export const getProduct = <ThrowOnError extends boolean = false>(options: Options<GetProductData, ThrowOnError>) => (options.client ?? client).get<GetProductResponses, GetProductErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/products/{id}', ...options });

/**
 * Update a product
 */
export const updateProduct = <ThrowOnError extends boolean = false>(options: Options<UpdateProductData, ThrowOnError>) => (options.client ?? client).put<UpdateProductResponses, UpdateProductErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/products/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm that a product image upload completed and attach it to the product.
 */
export const confirmProductImageUpload = <ThrowOnError extends boolean = false>(options: Options<ConfirmProductImageUploadData, ThrowOnError>) => (options.client ?? client).post<ConfirmProductImageUploadResponses, ConfirmProductImageUploadErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/products/{id}/images/confirm/{upload_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reorder product images.
 */
export const reorderProductImages = <ThrowOnError extends boolean = false>(options: Options<ReorderProductImagesData, ThrowOnError>) => (options.client ?? client).put<ReorderProductImagesResponses, ReorderProductImagesErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/products/{id}/images/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a presigned URL for uploading a product image.
 */
export const getProductImageUploadUrl = <ThrowOnError extends boolean = false>(options: Options<GetProductImageUploadUrlData, ThrowOnError>) => (options.client ?? client).post<GetProductImageUploadUrlResponses, GetProductImageUploadUrlErrors, ThrowOnError>({
    url: '/gas_admin/organizations/{org_id}/products/{id}/images/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a product image.
 */
export const deleteProductImage = <ThrowOnError extends boolean = false>(options: Options<DeleteProductImageData, ThrowOnError>) => (options.client ?? client).delete<DeleteProductImageResponses, DeleteProductImageErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/products/{id}/images/{image_id}', ...options });

/**
 * Mark a product image as primary (the one used at checkout).
 */
export const setPrimaryProductImage = <ThrowOnError extends boolean = false>(options: Options<SetPrimaryProductImageData, ThrowOnError>) => (options.client ?? client).post<SetPrimaryProductImageResponses, SetPrimaryProductImageErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/products/{id}/images/{image_id}/primary', ...options });

/**
 * Get a product's price-change history (newest first). Visible to any
 * member of the organization — used by gas_admin to audit pricing.
 */
export const listProductPriceHistory = <ThrowOnError extends boolean = false>(options: Options<ListProductPriceHistoryData, ThrowOnError>) => (options.client ?? client).get<ListProductPriceHistoryResponses, ListProductPriceHistoryErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/products/{id}/price-history', ...options });

/**
 * Get dashboard summary
 */
export const getDashboardSummary = <ThrowOnError extends boolean = false>(options: Options<GetDashboardSummaryData, ThrowOnError>) => (options.client ?? client).get<GetDashboardSummaryResponses, GetDashboardSummaryErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/reports/dashboard', ...options });

/**
 * Get deliveries report
 */
export const getDeliveriesReport = <ThrowOnError extends boolean = false>(options: Options<GetDeliveriesReportData, ThrowOnError>) => (options.client ?? client).get<GetDeliveriesReportResponses, GetDeliveriesReportErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/reports/deliveries', ...options });

/**
 * Get delivery time report
 */
export const getDeliveryTimeReport = <ThrowOnError extends boolean = false>(options: Options<GetDeliveryTimeReportData, ThrowOnError>) => (options.client ?? client).get<GetDeliveryTimeReportResponses, GetDeliveryTimeReportErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/reports/delivery-time', ...options });

/**
 * Get orders report
 */
export const getOrdersReport = <ThrowOnError extends boolean = false>(options: Options<GetOrdersReportData, ThrowOnError>) => (options.client ?? client).get<GetOrdersReportResponses, GetOrdersReportErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/reports/orders', ...options });

/**
 * Get revenue report
 */
export const getRevenueReport = <ThrowOnError extends boolean = false>(options: Options<GetRevenueReportData, ThrowOnError>) => (options.client ?? client).get<GetRevenueReportResponses, GetRevenueReportErrors, ThrowOnError>({ url: '/gas_admin/organizations/{org_id}/reports/revenue', ...options });

/**
 * WebSocket handler for driver clients
 *
 * Requires authentication via session cookie or session query parameter.
 * The driver_id in the query must match the authenticated driver's ID.
 */
export const wsDriverHandler = <ThrowOnError extends boolean = false>(options: Options<WsDriverHandlerData, ThrowOnError>) => (options.client ?? client).get<unknown, WsDriverHandlerErrors, ThrowOnError>({ url: '/realtime/drivers/ws', ...options });

/**
 * WebSocket handler for gas admin clients
 *
 * Requires authentication via session cookie. The authenticated user must
 * have access to the requested organization.
 */
export const wsGasAdminHandler = <ThrowOnError extends boolean = false>(options: Options<WsGasAdminHandlerData, ThrowOnError>) => (options.client ?? client).get<unknown, WsGasAdminHandlerErrors, ThrowOnError>({ url: '/realtime/gas_admin/ws', ...options });
